module.exports = __webpack_public_path__ + "static/media/back-to-doc.12cc4409.svg";